import {
    FETCH_CUSTOMER_TREATMENT_INCOME_REQUEST,
    FETCH_CUSTOMER_TREATMENT_INCOME_SUCCESS,
    FETCH_CUSTOMER_TREATMENT_INCOME_FAILURE,
  } from "./FetchCustomersTreatmentIncomeTypes";
  import api from "../../utils/Api";
  
  export const fetchCustomersTreatmentIncomeRequest = () => {
    return {
      type: FETCH_CUSTOMER_TREATMENT_INCOME_REQUEST,
    };
  };
  
  export const fetchCustomersTreatmentIncomeSuccess = (customersTreatmentIncome) => {
    return {
      type: FETCH_CUSTOMER_TREATMENT_INCOME_SUCCESS,
      payload: customersTreatmentIncome,
    };
  };
  
  export const fetchCustomersTreatmentIncomeFailure = (error) => {
    return {
      type: FETCH_CUSTOMER_TREATMENT_INCOME_FAILURE,
      payload: error,
    };
  };
  
  export const fetchCustomersTreatmentIncome = (sortBy, page, payload) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "/report/customer/fetch?sort_by="+sortBy + "&page="+ page;

    if(payload && payload.gender){
        url += "&gender="+ payload.gender;
    }
    if(payload && payload.age_range){
        url += "&age_range="+ payload.age_range;
    }
    
    return async (dispatch) => {
      dispatch(fetchCustomersTreatmentIncomeRequest());
      try {
        const response = await api.get(url,
          {
            headers: headers,
          }
        );
        const customersTreatmentIncome = response.data.data;
        //console.log("****** customer Treatment Income response", customersTreatmentIncome);
        dispatch(fetchCustomersTreatmentIncomeSuccess(customersTreatmentIncome));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchCustomersTreatmentIncomeFailure(errorMsg));
      }
    };
  };
  